// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"9d271d75","400":"6543a86e","517":"ba7e890c","578":"16305822","595":"f019ff8d","638":"e4370607","731":"d9f9145b","965":"0be61f91","967":"1b5ffa41"}[chunkId] + ".chunk.js";
};